import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SupportTicketSource } from '@nx-c4g/c4g-models';
import {
  SupportTicketHubDialogComponent,
  SupportTicketHubDialogData,
} from './support-ticket-hub-dialog.component';

export function openSupportTicketHubDialog(
  dialog: MatDialog,
  source: SupportTicketSource
): MatDialogRef<SupportTicketHubDialogComponent> {
  return dialog.open(SupportTicketHubDialogComponent, {
    width: '600px',
    maxWidth: '95vw',
    data: { source } as SupportTicketHubDialogData,
  });
}
